// extracted by mini-css-extract-plugin
export default {"thumb":"TC8OEo_sqpxAlkhTpnYE"};